/** Search + material filter state for the Inventory desk stock surface. */
import { useState } from "react";
import type { MfgMaterial } from "@/lib/manufacturing/types";
import type {
  ActiveFilter,
  MsdsStatusFilter,
  PriceFilter,
  QtyFilter,
  RecipeUsageFilter,
} from "./ManufacturingInventorySearchCard";
import { useManufacturingInventoryMaterialFilters } from "./useManufacturingInventoryMaterialFilters";

export function useManufacturingInventoryDeskFilters(
  materials: readonly MfgMaterial[],
  usedInRecipeIds: ReadonlySet<string>,
  usedInRecipeIdsReady: boolean,
) {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const [activeFilter, setActiveFilter] = useState<ActiveFilter>("active");
  const [msdsStatusFilter, setMsdsStatusFilter] = useState<MsdsStatusFilter>("all");
  const [recipeUsageFilter, setRecipeUsageFilter] = useState<RecipeUsageFilter>("all");
  const [qtyFilter, setQtyFilter] = useState<QtyFilter>("all");
  const [priceFilter, setPriceFilter] = useState<PriceFilter>("all");

  const { categories, existingUnits, existingShippingUnits, filtered } =
    useManufacturingInventoryMaterialFilters(
      materials,
      search,
      category,
      activeFilter,
      msdsStatusFilter,
      recipeUsageFilter,
      usedInRecipeIds,
      usedInRecipeIdsReady,
      qtyFilter,
      priceFilter,
    );

  return {
    search,
    setSearch,
    category,
    setCategory,
    activeFilter,
    setActiveFilter,
    msdsStatusFilter,
    setMsdsStatusFilter,
    recipeUsageFilter,
    setRecipeUsageFilter,
    qtyFilter,
    setQtyFilter,
    priceFilter,
    setPriceFilter,
    categories,
    existingUnits,
    existingShippingUnits,
    filtered,
  };
}
